export const dateAndTimeConversion = (date: string | Date, tZone: string) => {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
    timeZone: tZone,
  }
  const dateString = new Date(date).toLocaleString('en-US', options)
  const modifiedDate = dateString.split(',').slice(0, 2).join(', ')
  const modifiedTime = dateString.split(',')[2]
  return { modifiedDate, modifiedTime, dateString }
}

export const formatMonthYear = (date: string | Date, tZone = 'UTC') => {
  const dateObj = new Date(date)
  if (Number.isNaN(dateObj.getTime())) {
    return { month: '-', year: '-' }
  }

  const month = dateObj
    .toLocaleString('en-US', { month: 'short', timeZone: tZone })
    .toUpperCase()
  const year = dateObj
    .toLocaleString('en-US', { year: 'numeric', timeZone: tZone })
    .trim()

  return { month, year }
}
